import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  block: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing()
  },
  title: {
    marginBottom: theme.spacing(),
    textDecoration: 'underline'
  },
  payment: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(),
    '& p': {
      fontWeight: 500
    }
  },
  receiptButton: {
    alignSelf: 'flex-start',
    marginTop: theme.spacing(2),
    borderRadius: 10
  },
  state: {
    display: 'flex',
    gap: theme.spacing(),
    fontWeight: 500,
    fontSize: '1rem',
    fontFamily: theme.typography.fontFamily
  }
}))
